import React, { useMemo } from "react";

import useNurtureOffers from "../../hooks/useNurtureOffers";
import brandEventPropertyMapper from "../../utils/brandEventPropertyMapper";
import brandOfferEntityMapper from "../../utils/brandOfferEntityMapper";
import { SNOWPLOW_SCHEMA_DATA_KEY } from "../../utils/snowplowEventMigrator";
import { OfferContext } from ".";

function WidgetOfferManager({ children }) {
	const offersData = useNurtureOffers();
	const {
		NUM_OFFERS_IDX,
		TOTAL_OFFERS,
		areOffersEmpty,

		activeOffer,
		activeOfferIdx,
		setActiveOfferIdx,

		claimOffer,
		claimedOffers,
		isOfferClaimed,

		isFirstOffer,
		showNextOffer,
		showPrevOffer,
		isLastOffer,
	} = offersData;

	const defaultOfferEventProps = useMemo(() => {
		if (!activeOffer) return {};
		return {
			...brandEventPropertyMapper({
				brand: activeOffer,
				idx: activeOfferIdx,
				feedHasUpsell: false,
			}),
			[SNOWPLOW_SCHEMA_DATA_KEY]: {
				...brandOfferEntityMapper({
					brand: activeOffer,
				}),
				horizontalPosition: activeOfferIdx,
			},
		};
	}, [activeOffer, activeOfferIdx]);

	const value = {
		NUM_OFFERS_IDX,
		TOTAL_OFFERS,
		areOffersEmpty,

		activeOffer,
		activeOfferIdx,
		setActiveOfferIdx,

		claimOffer,
		claimedOffers,
		isOfferClaimed,

		isFirstOffer,
		showNextOffer,
		showPrevOffer,
		isLastOffer,

		defaultOfferEventProps,
	};

	return (
		<OfferContext.Provider value={value}>{children}</OfferContext.Provider>
	);
}

export default WidgetOfferManager;
